import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

import {
  GET_CLIENT_NAME,
  PREMIUM_FEATURE_DOWNLOAD_EXCEL_API,
  ADD_UPDATE_PREMIUM_FEATURE_API,
  GET_PREMIUM_FEATURE_DATA,
  GET_GEN_AI_STATUS_API,
} from '../endpoints/apiEndpoints'

export const getClientName = async () => {
  const url = urlBuilder(GET_CLIENT_NAME)
  const requestHeader = buildRequestHeader('GET')
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}


export const getPremiumFeatureData = async (feature) => {
  const url = urlBuilder(GET_PREMIUM_FEATURE_DATA,{feature})
  const requestHeader = buildRequestHeader('GET')
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const saveAndUpdatePremiumFeature = async (payload) => {
  const url = urlBuilder(ADD_UPDATE_PREMIUM_FEATURE_API)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadPremiumFeature = async (feature="GEN_AI") => {
  const url = urlBuilder(PREMIUM_FEATURE_DOWNLOAD_EXCEL_API,{},{feature})
  const requestHeader = buildRequestHeader('GET')
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getGenAiStatus = async () => {
  const url = urlBuilder(GET_GEN_AI_STATUS_API)
  const requestHeader = buildRequestHeader('GET')
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}